import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=7ca5d21c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca5d21c')) {
      api.createRecord('7ca5d21c', component.options)
    } else {
      api.reload('7ca5d21c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=7ca5d21c&", function () {
      api.rerender('7ca5d21c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fPX6oW4tXsFX/JS/offershelp.vue"
export default component.exports